import React from 'react';
import TableHeader from '../../BaseComponents/TableHeader';
import TableRowActionMenu from '../../BaseComponents/TableRowActionMenu';
import { AdminMember } from '../../../api/admin';
import './AdminsTable.scss';

const headerColumns = [
    { title: 'NAME', key: 'name', minWidth: '200px', width: '200px', flex: 1 },
    { title: 'EMAIL', key: 'email', minWidth: '250px', width: '250px', flex: 1 },
    { title: 'TEAM', key: 'team', minWidth: '140px', width: '140px', flex: 1 },
    { title: 'ROLE', key: 'role', minWidth: '120px', width: '120px', flex: 1 },
    { title: 'ACTION', key: 'action', minWidth: '80px', width: '80px', flex: 1 }
];

interface AdminsTableProps {
    admins: AdminMember[];
    onEdit?: (id: string | number) => void;
    onDisable?: (id: string | number) => void;
    isLoading?: boolean;
    onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
}

const AdminsTable: React.FC<AdminsTableProps> = ({
    admins,
    onEdit,
    onDisable,
    isLoading = false,
    onScroll
}) => {
    if (isLoading && admins.length === 0) {
        return <div className="admins-table-loading">Loading...</div>;
    }

    return (
        <div className="admins-table mt-0">
            <TableHeader headerColumns={headerColumns} gap={'28px'} />
            <div className="table-body" onScroll={onScroll}>
                {admins.length > 0 ? (
                    admins.map((admin) => (
                        <div key={admin.id} className={`table-row ${!admin.is_active ? 'disabled' : ''}`}>
                            <div className="column name">{`${admin.first_name} ${admin.last_name}`}</div>
                            <div className="column email">{admin.email}</div>
                            <div className="column team">
                                {admin.team_name || '-'}
                            </div>
                            <div className="column role">{admin.role}</div>
                            <div className="column action">
                                <TableRowActionMenu
                                    id={admin.id}
                                    options={[
                                        { key: 'edit', value: 'Edit' },
                                        { key: 'toggle', value: admin.is_active ? 'Disable' : 'Activate' }
                                    ]}
                                    onActionMenuClick={(id, action) => {
                                        if (action === 'toggle' && onDisable) onDisable(id);
                                        if (action === 'edit' && onEdit) onEdit(id);
                                    }}
                                />
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="empty-message">No administrators found.</div>
                )}
            </div>
        </div>
    );
};

export default AdminsTable;
